import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Seal } from '@paragon/contract-library';

interface SealState {
  readonly sealData: { readonly [region: string]: Seal };
}

const initialState: SealState = {
  sealData: {},
};

const sealsSlice = createSlice({
  name: 'seals',
  initialState,
  reducers: {
    addSeal: (state, action: PayloadAction<{ readonly loadedSeal: Seal }>) => {
      const { loadedSeal } = action.payload;

      state.sealData[loadedSeal.region] = loadedSeal;
    },
  },
});

export const { addSeal } = sealsSlice.actions;
export const seals = sealsSlice.reducer;
